import {
  EuiFormFieldset,
  EuiSwitch,
  EuiSplitPanel,
  EuiSpacer,
  EuiAvatar,
} from "@elastic/eui";

import { useState } from "react";

import { Viewport } from "./maps/MapGL";


export type CityProps = {
  viewport: Viewport;
  onChanged: () => void;
};

export function CityPicker(props:CityProps) {
  const options = [
    {value: '', text: '-- Pick City --'},
    {value: 'KOPER', text: 'Koper'},
    {value: 'STARIGRAD', text: 'STARIGRAD'},
  ];

  const [selected, setSelected] = useState(options[0].value);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelected(event.target.value);
    if(event.target.value=="KOPER"){
      props.viewport.latitude=45.5474330131125;
      props.viewport.longitude=13.728487466682799;
      props.viewport.bbox=[45.548,13.74,45.546, 13.72]
      props.viewport.zoom=15;
    
    }    
    else if(event.target.value=="STARIGRAD"){
      props.viewport.latitude=44.29613152006213;
      props.viewport.longitude=15.438914006166488;
      props.viewport.bbox=[44.297,15.45,44.295, 15.43]
      props.viewport.zoom=15;
    }
    props.onChanged();
  };

  return (
    <div className="euiFormControlLayout" style={{marginBottom:"20px"}} >
      <div className="euiFormControlLayout__childrenWrapper">
        <select value={selected} onChange={handleChange} className="euiSelect" style={{padding:"0px", paddingLeft:"10px"}}>
          {options.map(option => (
            <option key={option.value} value={option.value}>
              {option.text}
            </option>
          ))}
        </select>
   
      </div>
    </div>  
  );
}